document.addEventListener('DOMContentLoaded', function () {
    
let buttonProduct = document.querySelector("body.template-product .product-form__submit")
if(buttonProduct){
    buttonProduct.addEventListener("click", (e) => {
      //e.preventDefault()
      buttonProduct.classList.add("button-success")
      buttonProduct.querySelector('span').innerText = "ITEM ADDED"

      setTimeout(function(){
         buttonProduct.classList.remove("button-success")
        buttonProduct.querySelector('span').innerText = "ADD TO CART"
      },1000)
    
    });
}



});/* END READY */